export enum SaveSendMailJobMode {
  SAVE = 'SAVE',
  SAVE_AND_SEND = 'SAVE_AND_SEND',
}
